// src/pages/SettingsPage.jsx
import React from 'react';
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
} from '@/components/ui/card';

const SettingsPage = () => {
  return (
    <div className="space-y-6">
      <h2 className="text-3xl font-bold">Settings</h2>
      <Card>
        <CardHeader>
          <CardTitle>General Settings</CardTitle>
          <CardDescription>Manage your application settings.</CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground">Settings content will be added here.</p>
        </CardContent>
      </Card>
    </div>
  );
};

export default SettingsPage;